import AdminCMSList from "@/pages/admin/AdminCMSList";

export default function AdminMilestones() {
  return (
    <AdminCMSList
      testIdPrefix="admin-milestones" title="Milestone" subtitle="Pop Panda Journey"
      listEndpoint="/admin/milestones"
      createEndpoint="/admin/milestones"
      updateEndpoint={(id) => `/admin/milestones/${id}`}
      deleteEndpoint={(id) => `/admin/milestones/${id}`}
      blank={{ title: "", body: "", date_label: "", image_url: "", is_visible: true, sort_order: 0 }}
      fields={[
        { key: "title", label: "Title", full: true },
        { key: "date_label", label: "Date label (e.g. Apr 2024)" },
        { key: "sort_order", label: "Sort order", type: "number" },
        { key: "body", label: "Body", type: "textarea", full: true, rows: 3 },
        { key: "image_url", label: "Image URL", full: true },
        { key: "is_visible", label: "Visible on site", type: "checkbox", help: "Show on /journey", full: true },
      ]}
      renderCard={(m) => (
        <div className="p-5">
          <div className="text-[10px] uppercase tracking-[0.22em] text-brand-red">{m.date_label}</div>
          <div className="font-display text-xl mt-1">{m.title}</div>
          <p className="text-xs text-brand-charcoal/70 mt-2 line-clamp-3">{m.body}</p>
        </div>
      )}
    />
  );
}
